export const foodOrderLabels: Record<string, string> = {
  ORDER_STATUS_UNSPECIFIED: 'Не указан',
  ORDER_STATUS_PENDING: 'Ожидает подтверждения',
  ORDER_STATUS_AWAITING_PAYMENT: 'Ожидает оплаты',
  ORDER_STATUS_CONFIRMED: 'Подтверждён',
  ORDER_STATUS_PAID: 'Оплачен',
  ORDER_STATUS_DELIVERED: 'Доставлен',
  ORDER_STATUS_CANCELLED: 'Отменён',
  MERCHANT_ORDER_STATUS_UNSPECIFIED: 'Не указан',
  MERCHANT_ORDER_STATUS_NEW: 'Новый',
  MERCHANT_ORDER_STATUS_PREPARING: 'Готовится',
  MERCHANT_ORDER_STATUS_READY: 'Готов к выдаче',
  MERCHANT_ORDER_STATUS_PICKED_UP: 'Передан курьеру',
  MERCHANT_ORDER_STATUS_DELIVERED: 'Доставлен',
  MERCHANT_ORDER_STATUS_CANCELLED: 'Отменён',
  DELIVERY_STAGE_UNSPECIFIED: 'Не указан',
  DELIVERY_STAGE_AWAITING_MERCHANT: 'Ожидает ресторана',
  DELIVERY_STAGE_MERCHANT_ACCEPTED: 'Принят рестораном',
  DELIVERY_STAGE_COURIER_ASSIGNED: 'Курьер назначен',
  DELIVERY_STAGE_PICKED_UP: 'В пути',
  DELIVERY_STAGE_READY_FOR_PICKUP: 'Готов к выдаче',
  DELIVERY_STAGE_DELIVERED: 'Доставлен',
  STEP_STATE_UNSPECIFIED: 'Не указано',
  STEP_STATE_OK: 'Выполнено',
  STEP_STATE_ERROR: 'Ошибка',
  STEP_STATE_WAITING: 'Ожидание',
  STEP_STATE_CANCELLED: 'Отменено',
  STEP_SOURCE_UNSPECIFIED: 'Не указан',
  STEP_SOURCE_NOOR: 'Noor',
  STEP_SOURCE_IIKO: 'iiko',
  STEP_SOURCE_DELEVER: 'Delever',
  STEP_SOURCE_PAYMENT: 'Оплата',
  PAYMENT_TYPE_UNSPECIFIED: 'Не указан',
  PAYMENT_TYPE_CARD: 'Карта',
  DELIVERY_METHOD_UNSPECIFIED: 'Не указан',
  DELIVERY_METHOD_DELIVERY: 'Доставка',
  DELIVERY_METHOD_PICKUP: 'Самовывоз',
  cooking: 'Готовится',
  ready: 'Готов',
  on_the_way: 'В пути',
  rejected: 'Отклонён',
  delivered: 'Доставлен',
  noor: 'Noor',
  iko: 'iiko',
  delever: 'Delever',
  lakafe: 'LaKafe',
  customer: 'Клиент',
  admin: 'Администратор',
  restaurant: 'Ресторан',
  system: 'Система',
  aggregator: 'Агрегатор',
  none: 'Нет',
  pending: 'Ожидание',
  registered: 'Зарегистрирован',
  cancel_pending: 'Отмена в процессе',
  cancelled: 'Отменён',
  failed: 'Ошибка',
};
export const foodOrderLabel = (value?: string) =>
  value ? (foodOrderLabels[value] ?? value) : '—';
export function foodOrderTone(
  value?: string,
): 'secondary' | 'destructive' | 'success' | 'warning' {
  if (value && /ERROR|CANCELLED|failed|rejected|cancelled/.test(value))
    return 'destructive';
  if (value && /DELIVERED|_OK$|_PAID$|registered|delivered/.test(value)) return 'success';
  if (value && /PENDING|WAITING|NEW|pending/.test(value)) return 'warning';
  return 'secondary';
}
export const foodOrderMoney = (value?: number) =>
  value === undefined ? '—' : `${new Intl.NumberFormat('ru-RU').format(value)} сум`;
export function foodOrderDate(value?: string) {
  if (!value) return '—';
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? '—'
    : new Intl.DateTimeFormat('ru-RU', {
        timeZone: 'Asia/Tashkent',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
}
export const FOOD_ORDER_FILTERS = [
  { value: 'ADMIN_ORDER_FILTER_UNSPECIFIED', label: 'Все', count: 'all' },
  { value: 'ADMIN_ORDER_FILTER_CREATED', label: 'Созданные', count: 'created' },
  {
    value: 'ADMIN_ORDER_FILTER_AWAITING_MERCHANT',
    label: 'Ждут ресторана',
    count: 'awaiting_merchant',
  },
  { value: 'ADMIN_ORDER_FILTER_PREPARING', label: 'Готовятся', count: 'preparing' },
  { value: 'ADMIN_ORDER_FILTER_READY', label: 'Готовы', count: 'ready' },
  {
    value: 'ADMIN_ORDER_FILTER_COURIER_ASSIGNED',
    label: 'Курьер назначен',
    count: 'courier_assigned',
  },
  { value: 'ADMIN_ORDER_FILTER_ON_THE_WAY', label: 'В пути', count: 'on_the_way' },
  { value: 'ADMIN_ORDER_FILTER_COMPLETED', label: 'Завершённые', count: 'completed' },
  { value: 'ADMIN_ORDER_FILTER_CANCELLED', label: 'Отменённые', count: 'cancelled' },
  { value: 'ADMIN_ORDER_FILTER_PROBLEM', label: 'Проблемные', count: 'problem' },
] as const;
